export var ChoiceGroupOptionStyles = function ChoiceGroupOptionStyles(props) {
  var checked = props.checked,
      disabled = props.disabled,
      theme = props.theme,
      hasIcon = props.hasIcon,
      hasImage = props.hasImage;
  var semanticColors = theme.semanticColors,
      palette = theme.palette;
  return {
    field: [{
      selectors: {
        // The circle
        ':before': [{
          borderColor: palette.neutralPrimary
        }, disabled && {
          backgroundColor: semanticColors.bodyBackground,
          borderColor: palette.neutralTertiaryAlt
        }, checked && !disabled && {
          borderColor: semanticColors.inputBackgroundChecked // re-assign the semanticColor after changing it above

        }, (hasIcon || hasImage) && disabled && checked && {
          opacity: 1
        }],
        // The dot
        ':after': [checked && disabled && {
          borderColor: palette.neutralTertiaryAlt
        }],
        ':hover': [!disabled && {
          selectors: {
            '.ms-ChoiceFieldLabel': {
              color: palette.neutralDark
            },
            ':before': {
              borderColor: checked ? palette.themeDark : palette.neutralPrimary
            },
            ':after': [!hasIcon && !hasImage && !checked && {
              content: '""',
              transitionProperty: 'background-color',
              left: 5,
              top: 5,
              width: 10,
              height: 10,
              backgroundColor: palette.neutralSecondary
            }, checked && {
              borderColor: palette.themeDark
            }]
          }
        }]
      }
    }, (hasIcon || hasImage) && !disabled && {
      selectors: {
        ':hover': {
          borderColor: checked ? palette.themeDark : palette.neutralPrimary
        }
      }
    }, (hasIcon || hasImage) && {
      borderWidth: 1
    }, disabled && {
      selectors: {
        '.ms-ChoiceFieldLabel': {
          color: palette.neutralTertiary
        }
      }
    }, checked && disabled && {
      borderColor: palette.neutralLighter
    }],
    innerField: {
      margin: 1
    },
    choiceFieldWrapper: {
      selectors: {
        '&.is-inFocus': {
          selectors: {
            ':after': {
              borderColor: palette.neutralSecondary
            }
          }
        }
      }
    }
  };
};